import { ContentContext } from "@/providers/content/ContentContext";
import { useContext } from "react";

export const useContent = () => {
  const context = useContext(ContentContext);
  if (!context)
    throw new Error("useContent must be used within a ContextProvider");
  return context;
};
